import { Input, notification, Modal } from "antd";
import React, { useEffect, useRef, useState } from "react";
import { MyModal } from "../../../../components/styled-components";

interface MyModalProps {
  visible: boolean;
  onClose: () => void;
  onMatch: () => void;
  batchID?: string;
  trackingNo?: string;
  orderNo?: string;
}

const ConfirmModal: React.FC<MyModalProps> = ({
  visible,
  onClose,
  onMatch,
  trackingNo,
  orderNo,
}) => {
  const [userInput, setUserInput] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [isMatchSuccess, setIsMatchSuccess] = useState(false);
  const inputRef = useRef<any>(null);

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setUserInput(e.target.value);
  };

  useEffect(() => {
    if (!visible) {
      setUserInput("");
      setIsLoading(false);
      setIsMatchSuccess(false);
    } else if (visible && inputRef.current) {
      inputRef.current.focus();
    }
  }, [visible]);

  const checkMatch = () => {
    setIsLoading(true);
    const isMatch = trackingNo === userInput || orderNo === userInput;
    if (isMatch) {
      setIsMatchSuccess(true);
      onMatch();
    } else {
      notification.warning({
        message: "ข้อมูลไม่ถูกต้อง",
        description: "กรุณาใส่เลข Tracking หรือ Order ใหม่",
        duration: 4,
      });

      if (inputRef.current) {
        inputRef.current.focus();
      }

      setIsLoading(false);
    }

    setUserInput("");
  };

  const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === "Enter") {
      event.preventDefault();
      checkMatch();
    }
  };

  const confirmClose = () => {
    Modal.confirm({
      title: "ต้องการปิดหน้าต่างนี้ไหม",
      content: "order นี้จะไม่ถูกแพ็ค!!",
      onOk() {
        setUserInput("");
        onClose();
      },
      onCancel() {
        console.log("Cancel close");
      },
    });
  };

  return (
    <MyModal
      title="กรุณาสแกนใบปะหน้าเพื่อยืนยัน !!"
      open={visible}
      onOk={() => checkMatch()}
      onCancel={() => confirmClose()}
      okText="Ok"
      cancelText="Cancel"
      confirmLoading={isLoading}
      okButtonProps={{ disabled: isMatchSuccess }}
      cancelButtonProps={{ disabled: isMatchSuccess }}
    >
      <div>
        <Input
          value={userInput}
          onChange={handleInputChange}
          onKeyDown={handleKeyDown}
          ref={inputRef}
          disabled={isLoading || isMatchSuccess}
        />
      </div>
    </MyModal>
  );
};

export default ConfirmModal;
